<template>
  <div v-if="rule" class="rule rounded mb-4">
    <div class="px-4 py-3 d-flex d-flex-wrap align-center">
      <label class="mr-5">{{ rule.label }}</label>

      <!-- List of operands (optional) -->
      <select
        v-if="rule.operands"
        v-model="query.operand"
        class="inline-block w-auto h-10 px-1 py-2 leading-normal gray-500 border border-gray-300 rounded mr-2"
        :disabled="locked"
      >
        <option v-for="operand in rule.operands" :key="operand">{{
          operand
        }}</option>
      </select>

      <!-- List of operators (e.g. =, !=, >, <) -->
      <v-select
        v-if="rule.operators"
        v-model="query.operator"
        dense
        solo
        flat
        outlined
        :items="rule.operators"
        :readonly="rule.operators.length === 1"
        hide-details
        style="max-width: 70px"
        class="mr-2"
        :disabled="locked"
      >
      </v-select>

      <!-- Basic text input -->
      <v-text-field
        dense
        solo
        flat
        outlined
        v-if="rule.inputType === 'text'"
        v-model="query.value"
        type="text"
        :placeholder="labels.textInputPlaceholder"
        :disabled="locked"
      />

      <v-select
        v-if="rule.inputType === 'select'"
        v-model="query.value"
        dense
        solo
        flat
        outlined
        :items="rule.choices.map(x => ({ text: x.label, value: x.value }))"
        hide-details
        :disabled="locked"
      >
      </v-select>

      <v-spacer></v-spacer>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            elevation="0"
            v-if="depth > 1"
            @click="remove"
            v-on="on"
            v-bind="attrs"
            :disabled="locked"
          >
            <v-icon small>$close</v-icon>
          </v-btn>
        </template>
        <span>Remove</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import QueryBuilderRule from "vue-query-builder/dist/rule/QueryBuilderRule.umd.js";

export default {
  extends: QueryBuilderRule,
  props: {
    locked: Boolean
  }
};
</script>
